export class ProjectResponse {
  projectId?: string;
  projectName?: string;
  projectDescription?: string
  budgetFrame: number = 0;
  currencyCode:string = "";
  applicationDueDate?: Date;
  projectStatus?: string;
  startDate?: Date;
  dueDate?: Date;
  typeOfSupports:string[] = [];
  allowEmergencySubmit: boolean = false;
  allowFullSubmit: boolean = false;
}

export class GrantApplications {
  grantApplicationId?: string;
  name?: string;
  createdOn?: string;
}

export class ProjectDetailReponse {
  project?: ProjectResponse;
  grantApplications?: GrantApplications[];
}

